export enum Language {
  DE = "de",
  FR = "fr",
  IT = "it",
}
